import { SettingsSectionContainer } from '@/components/EventSettings/EventSettings.styles'
import EventSettingsActions from '@/components/EventSettings/EventSettingsActions'
import EventSettingsHeader from '@/components/EventSettings/EventSettingsHeader'
import EventSettingsSettings from '@/components/EventSettings/EventSettingsSettings'
import EventSettingsTabs from '@/components/EventSettings/EventSettingsTabs/EventSettingsTabs'
import { StreamEvent } from '@/types/streams/event'
import { EventEncoderDetails } from '@/types/streams/eventEncoder'

const EventSettings = ({
  selectedTab,
  event,
  encoderDetails
}: {
  selectedTab: 'actions' | 'settings'
  event: StreamEvent
  encoderDetails?: EventEncoderDetails
}) => {
  return (
    <SettingsSectionContainer>
      <EventSettingsHeader startDate={event.startDate} endDate={event.endDate} />
      <EventSettingsTabs selectedTab={selectedTab} />
      {selectedTab === 'settings' && encoderDetails ? (
        <EventSettingsSettings event={event} encoderDetails={encoderDetails} />
      ) : selectedTab === 'actions' ? (
        <EventSettingsActions event={event} />
      ) : null}
    </SettingsSectionContainer>
  )
}

export default EventSettings
